<div class="info-card">
  @if (street) {
    <div class="info-card__item">
      <span class="info-card__label">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.street' | translate }}</span>
      <span class="info-card__value">{{ street }}</span>
    </div>
  }
  @if (houseNumber) {
    <div class="info-card__item">
      <span class="info-card__label">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.housenumber' | translate }}</span>
      <span class="info-card__value">{{ houseNumber }}{{ boxNumber ? ' / ' + boxNumber : '' }}</span>
    </div>
  }
  @if (zipCode) {
    <div class="info-card__item">
      <span class="info-card__label">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.zipcode' | translate }}</span>
      <span class="info-card__value">{{ zipCode }}</span>
    </div>
  }
  @if (city) {
    <div class="info-card__item">
      <span class="info-card__label">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.city' | translate }}</span>
      <span class="info-card__value">{{ city }}</span>
    </div>
  }
  @if (country) {
    <div class="info-card__item">
      <span class="info-card__label">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.country' | translate }}</span>
      <span class="info-card__value">{{ country }}</span>
    </div>
  }
</div>
